var map = {
	"src/account/account.module": [
		"./src/account/account.module.ts",
		"common",
		"src-account-account-module"
	],
	"src/admin/admin.module": [
		"./src/admin/admin.module.ts",
		"src-admin-admin-module~src-films-films-module~src-games-games-module~src-search-search-module~src-tv~2093f761",
		"src-admin-admin-module~src-search-search-module~src-tv-series-tv-series-module",
		"src-admin-admin-module~src-films-films-module~src-search-search-module",
		"src-admin-admin-module~src-games-games-module~src-search-search-module",
		"common",
		"src-admin-admin-module"
	],
	"src/films/films.module": [
		"./src/films/films.module.ts",
		"src-admin-admin-module~src-films-films-module~src-games-games-module~src-search-search-module~src-tv~2093f761",
		"src-admin-admin-module~src-films-films-module~src-search-search-module",
		"common"
	],
	"src/games/games.module": [
		"./src/games/games.module.ts",
		"src-admin-admin-module~src-films-films-module~src-games-games-module~src-search-search-module~src-tv~2093f761",
		"src-admin-admin-module~src-games-games-module~src-search-search-module",
		"common"
	],
	"src/online/online.module": [
		"./src/online/online.module.ts",
		"common",
		"src-online-online-module"
	],
	"src/search/search.module": [
		"./src/search/search.module.ts",
		"src-admin-admin-module~src-films-films-module~src-games-games-module~src-search-search-module~src-tv~2093f761",
		"src-admin-admin-module~src-search-search-module~src-tv-series-tv-series-module",
		"src-admin-admin-module~src-films-films-module~src-search-search-module",
		"src-admin-admin-module~src-games-games-module~src-search-search-module",
		"common",
		"src-search-search-module"
	],
	"src/tv-series/tv-series.module": [
		"./src/tv-series/tv-series.module.ts",
		"src-admin-admin-module~src-films-films-module~src-games-games-module~src-search-search-module~src-tv~2093f761",
		"src-admin-admin-module~src-search-search-module~src-tv-series-tv-series-module",
		"common"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;